export default __webpack_public_path__ + "static/media/logo2.ba39029d.svg";